import React, { useState, useRef, useEffect } from 'react';

import axios from 'axios';
import { API_BASE_URL } from '../../ApiConfig';
import style from '../../../css/admin/Uploadform.module.css';
import { useNavigate } from 'react-router-dom';
import { getSecureToken } from '../../ApisService/apiService';


const UploadWindow = ({ onClose }) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [videoFiles, setVideoFiles] = useState([]);
    const [docFiles, setDocFiles] = useState([]);
    const [progress, setProgress] = useState(0);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [uploading, setUploading] = useState(false);
    const [online, setOnline] = useState(navigator.onLine);
    const [uploadSpeed, setUploadSpeed] = useState(null); // in KB/s or MB/s
    const navigate = useNavigate();

    useEffect(() => {
        const isAdmin = localStorage.getItem('islogin');
        if (!isAdmin || isAdmin !== 'true') {
            navigate('/admin');
        }
    }, []);

    useEffect(() => {
        const checkSession = async () => {
            const { secrettoken, ts } = await getSecureToken();
            try {
                const res = await axios.get(`${API_BASE_URL}adminauth/check_admin_session.php`, {
                    headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts,
                    },
                    withCredentials: true,
                });

                console.log(res.data);

                if (res.data.status !== "ok") {
                    navigate('/admin');
                }

            } catch (error) {
                console.error("Session check failed", error.response?.data || error.message);
                navigate('/admin');
            }
        };

        checkSession();
    }, []);


    const videoInputRef = useRef(null);
    const docInputRef = useRef(null);

    const MAX_FILES = 10;
    const CHUNK_SIZE = 5 * 1024 * 1024; // 10MB

    useEffect(() => {
        const updateOnlineStatus = () => setOnline(navigator.onLine);

        window.addEventListener('online', updateOnlineStatus);
        window.addEventListener('offline', updateOnlineStatus);

        return () => {
            window.removeEventListener('online', updateOnlineStatus);
            window.removeEventListener('offline', updateOnlineStatus);
        };
    }, []);




    // Validate total files count and file types
    const validateFiles = (newVideoFiles, newDocFiles) => {
        const totalCount = newVideoFiles.length + newDocFiles.length;
        if (totalCount > MAX_FILES) {
            setError(`You can upload maximum ${MAX_FILES} files in total.`);
            return false;
        }

        // Video file types check (common video mime types)
        const validVideoTypes = ['video/mp4', 'video/webm', 'video/ogg', 'video/quicktime', 'video/x-msvideo'];
        for (const file of newVideoFiles) {
            if (!validVideoTypes.includes(file.type)) {
                setError(`Invalid video file type: ${file.name}`);
                return false;
            }
        }

        // Document file types check
        const validDocExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
        for (const file of newDocFiles) {
            const ext = file.name.substring(file.name.lastIndexOf('.')).toLowerCase();
            if (!validDocExtensions.includes(ext)) {
                setError(`Invalid document file type: ${file.name}`);
                return false;
            }
        }

        setError('');
        return true;
    };

    const handleVideoFilesChange = (e) => {
        const selectedVideos = Array.from(e.target.files);
        if (validateFiles(selectedVideos, docFiles)) {
            setVideoFiles(selectedVideos);
        } else {
            videoInputRef.current.value = '';
        }
    };

    const handleDocFilesChange = (e) => {
        const selectedDocs = Array.from(e.target.files);
        if (validateFiles(videoFiles, selectedDocs)) {
            setDocFiles(selectedDocs);
        } else {
            docInputRef.current.value = '';
        }
    };

    const uploadFileInChunks = async (file, onProgress, onChunkUploaded) => {
        const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
        let uploadedSize = 0;

        for (let i = 0; i < totalChunks; i++) {
            const start = i * CHUNK_SIZE;
            const end = Math.min(file.size, start + CHUNK_SIZE);
            const chunk = file.slice(start, end);

            const formData = new FormData();
            formData.append('file', chunk);
            formData.append('filename', file.name);
            formData.append('chunkIndex', i);
            formData.append('totalChunks', totalChunks);

            const startTime = performance.now();
            const { secrettoken, ts } = await getSecureToken();
            await axios.post(`${API_BASE_URL}workshop_uploads/upload_chunk.php`, formData, {
                timeout: 5 * 60 * 1000,
                maxContentLength: Infinity,
                maxBodyLength: Infinity,
                headers: {
                    'X-TOKEN': secrettoken,
                    'X-TIMESTAMP': ts,
                },
                  withCredentials: true,
            });

            const endTime = performance.now();
            const timeTaken = (endTime - startTime) / 1000;
            const speed = (chunk.size / 1024 / timeTaken).toFixed(2);

            setUploadSpeed(speed);

            uploadedSize += chunk.size;
            const progress = Math.round((uploadedSize / file.size) * 100);
            onProgress(progress);
            onChunkUploaded && onChunkUploaded();
        }
    };

    // const handleSubmit = async (event) => {
    //     event.preventDefault();
    //     setUploading(true);
    //     setProgress(0);
    //     setMessage('');
    //     setError('');

    //     try {
    //         const totalFiles = videoFiles.length + docFiles.length;
    //         if (totalFiles === 0) {
    //             setError('Please select at least one file to upload.');
    //             setUploading(false);
    //             return;
    //         }

    //         let uploadedFiles = 0;
    //         const actualMergedNames = [];
    //         let uploadedFileNames = [];


    //         for (const file of videoFiles) {
    //             await uploadFileInChunks(file, (fileProgress) => {
    //                 const overallProgress = Math.round(((uploadedFiles + fileProgress / 100) / totalFiles) * 100);
    //                 setProgress(overallProgress);
    //             });

    //             const mergeRes = await axios.post(`${API_BASE_URL}workshop_uploads/merge_chunks.php`, {
    //                 filename: file.name,
    //             });

    //             if (!mergeRes.data.success) {
    //                 throw new Error(`Merge failed for file: ${file.name}. Message: ${mergeRes.data.message}`);
    //             }

    //             actualMergedNames.push(mergeRes.data.finalName);
    //             uploadedFiles++;
    //         }


    //         if (docFiles.length > 0) {
    //             const docFormData = new FormData();
    //             docFiles.forEach(file => {
    //                 docFormData.append('documents[]', file);
    //             });

    //             const response = await axios.post(`${API_BASE_URL}workshop_uploads/upload_documents.php`, docFormData, {
    //                 headers: { 'Content-Type': 'multipart/form-data' }
    //             });

    //             if (response.data.success) {
    //                 uploadedFileNames = response.data.uploadedFiles;
    //             } else {
    //                 throw new Error(response.data.message || 'Document upload failed');
    //             }

    //             uploadedFiles += docFiles.length;
    //             setProgress(100);
    //         }


    //         await axios.post(`${API_BASE_URL}workshop_uploads/workshop_upload.php`, {
    //             title,
    //             description,
    //             videoNames: actualMergedNames,
    //             documentNames: uploadedFileNames,
    //         });

    //         setMessage('Upload successful!');
    //         setTitle('');
    //         setDescription('');
    //         setVideoFiles([]);
    //         setDocFiles([]);
    //         videoInputRef.current.value = '';
    //         docInputRef.current.value = '';
    //     } catch (error) {
    //         console.error(error);
    //         setMessage('Upload failed!');
    //     } finally {
    //         setUploading(false);
    //     }
    // };
  
    const handleSubmit = async (event) => {
        event.preventDefault();
        setUploading(true);
        setProgress(0);
        setMessage('');
        setError('');

        try {
            const totalFiles = videoFiles.length + docFiles.length;
            if (totalFiles === 0) {
                setError('Please select at least one file to upload.');
                setUploading(false);
                return;
            }

            let uploadedFiles = 0;
            const actualMergedNames = [];
            let uploadedFileNames = [];

            // Upload videos in chunks
            for (const file of videoFiles) {
                // Pass token function to chunk uploader
                const getHeaders = async () => {
                    const { secrettoken, ts } = await getSecureToken();
                    return {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts,
                    };
                };

                await uploadFileInChunks(
                    file,
                    (fileProgress) => {
                        const overallProgress = Math.round(((uploadedFiles + fileProgress / 100) / totalFiles) * 100);
                        setProgress(overallProgress);
                    },
                    null,
                    getHeaders 
                );

                // Token for merge_chunks
                const { secrettoken, ts } = await getSecureToken();
                const mergeRes = await axios.post(
                    `${API_BASE_URL}workshop_uploads/merge_chunks.php`,
                    { filename: file.name },
                    {
                        headers: {
                            'X-TOKEN': secrettoken,
                            'X-TIMESTAMP': ts,
                        },
                        withCredentials: true,
                    }
                );

                if (!mergeRes.data.success) {
                    throw new Error(`Merge failed for file: ${file.name}. Message: ${mergeRes.data.message}`);
                }

                actualMergedNames.push(mergeRes.data.finalName);
                uploadedFiles++;
            }

            // Upload docs/images
            if (docFiles.length > 0) {
                const docFormData = new FormData();
                docFiles.forEach(file => {
                    docFormData.append('documents[]', file);
                });

                const { secrettoken, ts } = await getSecureToken();

                const response = await axios.post(
                    `${API_BASE_URL}workshop_uploads/upload_documents.php`,
                    docFormData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'X-TOKEN': secrettoken,
                            'X-TIMESTAMP': ts,
                        },
                        withCredentials: true,
                    }
                );

                if (response.data.success) {
                    uploadedFileNames = response.data.uploadedFiles;
                } else {
                    throw new Error(response.data.message || 'Document upload failed');
                }

                uploadedFiles += docFiles.length;
                setProgress(100);
            }

            // Submit metadata
            const { secrettoken, ts } = await getSecureToken();

            await axios.post(
                `${API_BASE_URL}workshop_uploads/workshop_upload.php`,
                {
                    title,
                    description,
                    videoNames: actualMergedNames,
                    documentNames: uploadedFileNames,
                },
                {
                    headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts,
                    },
                    withCredentials: true,
                }
            );

            // Success
            setMessage('Upload successful!');
            setTitle('');
            setDescription('');
            setVideoFiles([]);
            setDocFiles([]);
            videoInputRef.current.value = '';
            docInputRef.current.value = '';
        } catch (error) {
            console.error(error);
            setMessage('Upload failed!');
        } finally {
            setUploading(false);
        }
    };



    return (

        <div className={style.pageWrapper}>
            <header className={style.header}>Upload Workshop</header>

            <div className={style.formContainer}>
                <form onSubmit={handleSubmit} className={style.uploadForm}>
                    <label>Title</label>
                    <input type="text" required value={title} onChange={(e) => setTitle(e.target.value)} disabled={uploading} />

                    <label>Description</label>
                    <textarea value={description} onChange={(e) => setDescription(e.target.value)} disabled={uploading} />

                    <label>Upload Videos</label>
                    <input
                        type="file"
                        accept="video/*"
                        multiple
                        onChange={handleVideoFilesChange}
                        disabled={uploading}
                        ref={videoInputRef}
                    />

                    <label>Upload Docs/Images</label>
                    <input
                        type="file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx"
                        multiple
                        onChange={handleDocFilesChange}
                        disabled={uploading}
                        ref={docInputRef}
                    />

                    {error && <p style={{ color: 'red', marginTop: '5px' }}>{error}</p>}

                    <button type="submit" className={style.uploadButton} disabled={uploading || error}>
                        {uploading ? 'Uploading...' : 'Start Upload'}
                    </button>
                </form>


                <div className={style.statusSection}>
                    <p><span style={{ color: online ? 'green' : 'red' }}><strong>Status:</strong> {online ? 'Online' : 'Offline'}</span></p>
                </div>



                {progress > 0 && (
                    <div className={style.progressWrapper}>
                        <p>Uploading... {progress}% </p>
                        <p><strong>Upload Speed:</strong> {uploadSpeed ? `${uploadSpeed} KB/s` : 'Calculating...'}</p>

                        <div className={style.progressBar}>
                            <div className={style.progress} style={{ width: `${progress}%` }}></div>
                        </div>
                    </div>
                )}


                {message && <p className={style.message}>{message}</p>}

                <a href="/admin_dash/Workshop_upload" className={style.goBack}>← Go Back</a>
            </div>
        </div>
    );
};

export default UploadWindow;
